module.exports = __webpack_public_path__ + "img/Img-main.266cf716.png";